import React, { SyntheticEvent } from 'react';
import { Button } from '@wds/button';

import useTrackingDetails from '~pricing/hooks/useTrackingDetails';

import useCta from '../../hooks/useCta';
import { generateCTAMetricsAttribute } from '~pricing/pages/shared/index';
import { PackageIds } from '~shared/constants/pricing';

import useStyles from '~pricing/components/PackageCta/useStyles';
import { usePricingState } from '~shared/hooks/usePricingState';
import { PackageCTAProps } from '~app/pages/Pricing/components/PackageCta/types';

const PackageCta = ({ packageName, isSummaryPage = false, className = '' }: PackageCTAProps): JSX.Element => {
  const {
    state: {
      packages: { getPackageById },
      grow2792: { isIPPM = false },
    },
  } = usePricingState();

  const { CTA, noCTA, noShow } = useStyles({ packageName });
  const packageId = PackageIds[packageName];
  const { pageName } = useTrackingDetails();
  const { isEnabled, ctaUrl, ctaLabel } = useCta(getPackageById(packageId));

  const handlePackageSelectClick = (e: SyntheticEvent, CTA_URL: string): void => {
    e.preventDefault();
    if (window) {
      window.parent.postMessage(
        {
          action: 'open_checkout_link',
          checkoutURL: CTA_URL,
        },
        window.location.origin
      );
    }
  };

  return (
    <div className={`${className} ${isEnabled ? CTA : noCTA} ${!ctaLabel ? noShow : ''}`}>
      <Button
        data-sm-metrics={generateCTAMetricsAttribute({
          pageName,
          packageId: `${packageId}`,
          packageName, // lowercase canonical_name
        })}
        color={isEnabled ? 'primary' : 'secondary'}
        href={ctaUrl}
        {...(isIPPM && { onClick: (e: SyntheticEvent) => handlePackageSelectClick(e, ctaUrl) })}
        variant={isEnabled ? 'solid' : 'ghost'}
        disabled={!isEnabled}
        stretched={!isEnabled}
        data-testid="PackageCta__Btn"
        size={isSummaryPage ? 'md' : 'sm'}
      >
        {ctaLabel}
      </Button>
    </div>
  );
};

export default PackageCta;
